import { PacksClient } from '../types'
import { CreatePackPayload, JoinPackResponse } from '../types/PacksClient'

export const createPack = (base: PacksClient) => (data: CreatePackPayload) =>
  base.requester.post<JoinPackResponse>('', data , { withCredentials: true })
